import * as Yup from 'yup'

export default Yup.object().shape({
  otpCode: Yup.string().required('Required.').min(6)
})
